module.exports = __webpack_public_path__ + "static/media/ShapeLeft.533680b7.svg";